export { default } from './SimulatorRigsPage'
